import { useLocation } from 'react-router-dom';

/**
 * Returns true when the current URL contains `redirect=seedsOnboarding`.
 * Used to render the demo-mode report view where interactive elements
 * (Contact, Share, logo click, footer links) are disabled and a fixed
 * "Get your Seed Recommendation" CTA is shown at the bottom.
 */
const useSeedsOnboarding = (): boolean => {
  const location = useLocation();
  return new URLSearchParams(location.search).get('redirect') === 'seedsOnboarding';
};

export default useSeedsOnboarding;
